import ko from 'lib/knockout';
import * as _ from "lib/underscore";
import {Router, NavUrl} from './router';
import {asArray} from "../var";
import * as loggerUtils from "../logger";

const logger = loggerUtils.newLogger('Query');

export class Query {
	_router = null;
	_queryData = ko.observable({});
	_defaults = ko.observable({});
	_lastChange = {};

	delimiter = '-';

	/**
	 * @param {Router} router
	 */
	constructor(router) {
		this._router = router;
		router.onInitialize(navData => {
			this._onRouterChange(navData);

			this._queryData.subscribe((queryData) => {
				const url = this._constructUrl(queryData);
				const lastChange = this._lastChange;
				this._router.navigate(url, {lastChange});
			});
		});
		router.onNavigate(this._onRouterChange.bind(this));
	}

	onChange(callback) {
		this._queryData.subscribe(callback);
	}

	setDefaults(defaults) {
		const newValue = _.extend({}, this._defaults(), this._toString(defaults));
		this._defaults(newValue);
	}

	getQuery() {
		return this._queryData();
	}

	getQueryParam(key, defaultValue) {
		const value = this._queryData()[key];
		if (value) {
			return value;
		} else if (defaultValue !== undefined) {
			return defaultValue;
		} else if (this._defaults()[key] !== undefined) {
			return this._defaults()[key];
		} else {
			return '';
		}
	}

	getQueryParamAsArray(key, defaultValue = []) {
		return asArray(this.getQueryParam(key, defaultValue), this.delimiter);
	}

	setQuery(params, reset) {
		this._setQueryData(params, reset);
	}

	setQueryParam(key, value, reset) {
		this.setQuery({[key]: value}, reset);
	}

	getLastSetKeys() {
		return this._lastChange;
	}

	_toString(val) {
		if (_.isArray(val)) {
			val = _.map(val, v => this._toString(v));
			val = _.filter(val, v => !!v);
		} else if (_.isObject(val)) {
			val = _.mapObject(val, v => this._toString(v));
			val = _.pick(val, v => !!v);
		} else if (val === true) {
			val = '1';
		} else if (val === false) {
			val = '0';
		} else if (val) {
			val = '' + val;
		} else {
			val = null;
		}
		return val;
	}

	generateUrl(params, reset) {
		const data = this._newQueryData(params, reset);
		return this._router.baseUrl + this._constructUrl(data);
	}

	addValue(key, value) {
		this.setQuery({
			[key]: this.getQueryParamAsArray(key).concat(value)
		});
	}

	toggleValue(key, value) {
		value = "" + value;
		const selected = [...this.getQueryParamAsArray(key)];
		if (selected.indexOf(value) >= 0) {
			ko.utils.arrayRemoveItem(selected, value);
		} else {
			selected.push(value);
		}
		this.setQuery({[key]: selected});
	}

	removeValue(key, value) {
		const selected = [...this.getQueryParamAsArray(key)];
		ko.utils.arrayRemoveItem(selected, value);
		this.setQuery({[key]: selected});
	}

	resetQuery() {
		this.setQuery({}, true);
	}

	_setQueryData(params, reset = false) {
		this._lastChange = reset ? {} : {...params};
		const data = this._newQueryData(params, reset);
		if (!_.isEqual(this._queryData(), data)) {
			logger.log('set query:', data);
			this._queryData(data);
			return true;
		}
		return false;
	}

	_newQueryData(params, reset = false) {
		let data = reset ? {...params} : {...this._queryData(), ...params};
		data = this._toString(data);
		data = _.pick(data, (v, k) => {
			return v !== this._defaults()[k];
		});
		return data;
	}

	_onRouterChange(navData) {
		const params = {...navData.params, ...navData.queryData};
		this._setQueryData(params, true);
	}

	/**
	 *
	 * @param {object} selection
	 * @return {NavUrl}
	 */
	_constructUrl(selection) {
		// convert array values into delimited strings
		const p = _.mapObject(selection, val => {
			if (_.isArray(val)) {
				return _.map(val, v => v).join(this.delimiter);
			} else {
				return val
			}
		});
		return new NavUrl('', p);
	}
}



// WEBPACK FOOTER //
// ./core/utils/nav/query.js